import {
    IonButton,
    IonCard,
    IonContent,
    IonFooter,
    IonItem,
    IonPage,
    IonRadio,
    IonRadioGroup,
    IonText,
    useIonRouter,
} from "@ionic/react";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderComponent } from "../../components";
import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useUsername } from "../../components/hooks";
import { setShowOnBoardingFlow } from "../../redux/actions/appStatus";
import { routes } from "../../route/constants";

export const OnBoardingTimerSettingsStepTwo: FC = () => {
    const { t } = useTranslation();
    const settings = useSelector((root: RootState) => root.settings);
    const { elapsedHalfTimerFromZero } = settings.settings;
    const [shouldRestartTimer, setShouldRestartTimer] = useState<boolean>(
        elapsedHalfTimerFromZero
    );
    const route = useIonRouter();
    const username = useUsername();
    const dispatch = useDispatch();

    const handleNextClicked = () => {
        dispatch(setShowOnBoardingFlow(false));
        return route.push(
            routes.onBoardingSetupComplete,
            "root",
            "replace"
        );
    };

    return (
        <IonPage>
            <HeaderComponent
                titleTestId="timer-settings-header-2"
                title={t("settings.TimerSettings.title")}
                showProgressBar={true}
                progressValue={0.6}
            />
            <IonContent>
                <h2
                    className="text-weight-bold text-large align-center uppercase"
                    style={{
                        width: "100%",
                        marginTop: 20,
                        fontWeight: 400,
                        fontSize: 14,
                    }}
                >
                    {t("help.onBoarding.shouldRestartTimerDesc")}
                </h2>

                <IonCard color="transparent"></IonCard>
            </IonContent>
            <IonFooter>
                <IonButton
                    expand="block"
                    data-testid="timer-settings-next-button-2"
                    onClick={() => handleNextClicked()}
                >
                    {t("general.next")}
                </IonButton>
            </IonFooter>
        </IonPage>
    );
};
